module.exports = __webpack_public_path__ + "img/pos-entry-exit.d4553bf0.png";